<template>
  <v-snackbar
      v-model="snackBarModel"
      :bottom="true"
      :right="true"
      multi-line
    >
      {{ messageErreur.message }}
      <v-btn
        color="primary"
        flat
        @click="fermerSnackBar"
      >
        Fermer
      </v-btn>
    </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
import { MESSAGE_ERREUR_MUTATION } from '@/store'

export default{
  computed: {
    snackBarModel: {
      get(){
        return this.messageErreur.visible
      },
      set(){
        this.fermerSnackBar()
      }
    },
    ...mapState(['messageErreur'])
  },
  methods: {
    fermerSnackBar(){
      this.$store.commit(MESSAGE_ERREUR_MUTATION,{
        visible: false,
        message: ''
      })
    }
  }
}
</script>